import script from "./config-card.vue?vue&type=script&setup=true&lang=js"
export * from "./config-card.vue?vue&type=script&setup=true&lang=js"

import "./config-card.vue?vue&type=style&index=0&id=604cfa01&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-604cfa01"]])

export default __exports__